import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

// Only a build with the front door on (lib/frontDoor/flag.ts) has this page; any other build sends /start to sign-in.
// The router loads it before it leaves /landing, which has already fetched it, so nothing blank shows in between.
const StartPage =
  import.meta.env.VITE_FRONT_DOOR === 'true'
    ? lazyRouteComponent(() => import('../components/FrontDoor/StartPage'), 'StartPage')
    : null

export const Route = createFileRoute('/start')({
  beforeLoad: () => {
    if (!StartPage) throw redirect({ to: '/login' })
  },
  component: StartPage ?? (() => null),
})
